"use client";

import type * as React from "react";

export interface MarketingPricingSectionProps {
	/** Kept for backwards-compat relocation; not used on launch home. */
	children?: React.ReactNode;
}

export function MarketingPricingSection({
	children,
}: MarketingPricingSectionProps) {
	return (
		<section id="pricing" className="scroll-mt-20 py-12 lg:py-16 xl:py-24">
			<div className="container">{children}</div>
		</section>
	);
}
